export default "__VITE_ASSET__Q_R$B4EY__"